module.exports = __webpack_public_path__ + "static/media/area.7add8343.svg";